import styled from 'styled-components'
import border from '../../tokens/border'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import layout from '../../tokens/layout'
import typography from '../../tokens/typography'
import ShadowToken from '../../tokens/shadow'

export const TextSpacer = styled.span`
  display: block;
  margin-left: 0.8rem;
`

function getContainerHeight(length): number {
  const BUTTONHEIGHT = 4.3
  const SUBMENUHEIGHT = 4.9
  const BOTTOM_SPACING = 1.6
  return SUBMENUHEIGHT * length + BUTTONHEIGHT + BOTTOM_SPACING
}

export const Submenu = styled.ul<{ length?: number }>`
  margin-top: ${(props) =>
    props.length
      ? `-${getContainerHeight(props.length)}rem;`
      : layout.margin.spacingNano};
  background: ${colors.neutralColorHighPure};
  border: ${border.width.widthHairline} solid #eef2f9;
  border-radius: ${border.radius.radiusSm};
  padding: ${layout.padding.spacingInsetQuarck};
  list-style: none;
  box-shadow: ${ShadowToken.shadowLevel1};
  width: 252px;
  z-index: 10;
  position: absolute;
`

export const Subitem = styled.li<{ disabled?: boolean }>`
  padding: ${layout.padding.spacingInsetXs} ${layout.padding.spacingInsetNano};
  cursor: ${(props) => (!props.disabled ? 'pointer' : 'not-allowed')};
  &:hover {
    color: ${colors.neutralColorLowMedium};
    background-color: ${colors.neutralColorHighLight};
    transition: color 0.25s;
  }
`

export const ActionLink = styled.div<{
  disabled?: boolean
  isDanger?: boolean
}>`
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
  -webkit-font-smoothing: inherit;
  align-items: center;
  background: transparent;
  border: none;
  color: ${(props) =>
    !props.disabled
      ? props.isDanger
        ? colors.feedbackColorNegativePure
        : colors.neutralColorLowPure
      : colors.neutralColorLowMedium};
  display: flex;
  font-family: ${fonts.inter};
  font-size: ${typography.fontSize.fontSizeXxs};
  font-style: normal;
  font-weight: ${typography.fontWeight.fontWeightRegular};
  line-height: normal;
  margin: ${layout.margin.spacingNone};
  outline: 0;
  overflow: visible;
  padding: ${layout.padding.spacingInsetNone};
  text-align: left;
  text-decoration: none;
  width: auto;
`

export const ContainerButton = styled.div`
  position: relative;
`
